<div class="login-container">
    <div class="container">
        <div class="row">
            <div class="col">
                <p class="logo header">PORTFOLIO</p>
            </div>
        </div>
    </div>
    <div class="container">
        <form class="container ">
            <div class="row justify-content-center criteria-box">
                <div class="col-12 col-sm-5 label">
                    {{'dpo.i18n.label.username' | translate}}
                </div>
                <input #usernameInput matInput class="col-12 col-sm-7 field input" type="text" [(ngModel)]="username" name="username" />
            </div>
            <div class="row justify-content-center criteria-box">
                <div class="col-12 col-sm-5 label">
                    {{'dpo.i18n.label.password' | translate}}
                </div>
                <input class="col-12 col-sm-7 field input" type="password" [(ngModel)]="password" name="password" />
            </div>
            <div class="row">
                <div class="col action-button">
                    <button class="btn" type="submit"
                        (click)="login()">{{'dpo.i18n.login.button.signin' | translate}}</button>
                    <button class="btn" type="submit"
                        (click)="cancel()">{{'dpo.i18n.login.button.cancel' | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</div>